<!--
  usage:
    <currency-input id="idForElement" v-model="auction.startingPrice" inputStyle="width:50%" required disabled />
-->
<template>
  <span>
    <input :id="id" :required="required" :disabled="disabled" :style="inputStyle" type="tel"
           v-model="displayValue" @input="updateValue($event.target.value)" />
  </span>
</template>

<script>

  export default {
    name: 'CurrencyInput',
    props: {
      value: {
        type: [String, Number],
        required: false,
        default: ''
      },
      id: {
        type: String,
        required: true
      },
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      inputStyle: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        numberValue: -1
      }
    },
    computed: {
      displayValue: {
        get() {
          if (this.numberValue < 0) return ''
          let s = String(this.numberValue)
          s = this.reverseString(this.reverseString(s).replace(/(...)/g, '$1,')) // convert e.g. 1234567 -> "1,234,567"
          if (s.indexOf(',') === 0) s = s.substr(1) // remove first comma e.g. ",123" -> "123"
          return '$' + s
        },
        set(newValue) {
          this.numberValue = newValue
        }
      }
    },
    watch: {
      value() {
        this.calculateNumberValue()
      }
    },
    created() {
      this.calculateNumberValue()
    },
    methods: {
      calculateNumberValue() {
        let i = parseInt(this.value)
        if (isNaN(i) || i < 0) i = -1
        this.numberValue = i
      },
      reverseString(str) {
        return str.split('').reverse().join('')
      },
      updateValue(value) {
        value = value.replace(/[^0-9]/g, '') // remove everything else than numbers
        let n = parseInt(value)
        if (isNaN(n)) n = -1
        this.numberValue = n
        this.$emit('input', this.numberValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/elements/CurrencyInput.vue